import { Component, Input, OnInit } from '@angular/core';
import { ChecksService } from '../../../_services/checks.service';
import { AdminData } from '../../../_models/admin';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit {
  @Input() page: string;
  @Input() subPage: string;
  userData: AdminData = new AdminData();

  navItems = [
    { label: 'Dashboard', icon: 'fas fa-th-large', route: ['/'], active: ['dashboard'], page: null },
    { label: 'Dealslip', icon: 'far fa-file-alt', route: ['/dealslip'], active: ['dealslip'], page: 'dealSlip' },
    { label: 'Cross Exchange Rate', icon: 'fas fa-exchange-alt', route: ['/dealslip', 'cross-exchange-rate'], active: ['dealslip'], subPages: ['cross-exchange-rate'], page: 'dealSlip' },
    { label: 'HR & People', icon: 'fas fa-user-friends', route: ['/hr', 'employee-profiles-kin'], active: ['hr'], page: ['hr.staff', 'hr.leave', 'hr.expense', 'hr.announcement', 'users'] },
    { label: 'Treasury', icon: 'fas fa-university', route: ['/treasury'], active: ['treasury'], page: 'treasury' },
    { label: 'Finance & P&L', icon: 'fas fa-chart-line', route: ['/finance-pl', 'pl-statement'], active: ['finance-pl'], page: 'finance.pl' },
    { label: 'Compliance', icon: 'far fa-clipboard', route: ['/users'], active: ['users'], page: ['users', 'users.kyc'] },
    { label: 'Settings', icon: 'fas fa-cog', route: ['/settings', 'administrator'], active: ['settings'], page: ['administrators', 'administrators.right', 'country', 'document.type', 'settings'] },
  ];

  constructor(public checkService: ChecksService) { }

  ngOnInit(): void {
    this.userData = this.checkService.getAdminData();
  }

  canRead(page: string|string[]|null) {
    if (page === null || page === undefined) {
      return true;
    }
    return this.checkService.canRead(page);
  }

  userName(): string {
    const name = [this.userData?.firstName, this.userData?.lastName].filter(Boolean).join(' ').trim();
    return name || this.userData?.nickName || 'Admin';
  }

  isActive(item) {
    const pageMatch = (item.active || []).includes(this.page);
    const subPages = item.subPages || [];
    return pageMatch && (subPages.length === 0 || subPages.includes(this.subPage));
  }

}
